import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, TextField, InputAdornment, Box, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { Link as RouterLink } from 'react-router-dom';

export default function ListUsers() {
    const [users, setUsers] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    
    const { isLoading: isLoadingusers, refetch: getusers } = useQuery(
        "load-users",
        async () => {
          return await apiClient.get("/api/users");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setUsers(res.data.users);
                setFilteredUsers(res.data.users);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
    // Search users from API
    const { isLoading: isSearching, refetch: searchUsers } = useQuery(
        ["search-users", searchTerm],
        async () => {
          return await apiClient.get(`/api/users/search?query=${searchTerm}`);
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setFilteredUsers(res.data.users);
            }
          },
          onError: (err) => {
            // Error handling
          },
        }
    );
    
    // Handle search input change
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        
        if (value.length === 0) {
            // Reset to all users if search is cleared
            setFilteredUsers(users);
        } else if (value.length > 2) {
            // Search API if term is at least 3 characters
            searchUsers();
        }
    };

    // Local search function as a fallback/alternative to API search
    const handleLocalSearch = () => {
        if (!users) return;
        
        if (searchTerm.trim() === '') {
            setFilteredUsers(users);
            return;
        }
        
        const term = searchTerm.toLowerCase();
        const results = users.filter(user => 
            user.name?.toLowerCase().includes(term) || 
            user.email?.toLowerCase().includes(term) || 
            user.phone?.toLowerCase().includes(term) ||
            user.country?.toLowerCase().includes(term)
        );
        
        setFilteredUsers(results);
    };

    // Search when enter key is pressed
    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && searchTerm.trim() !== '') {
            searchUsers();
        }
    };

    useEffect(() => {
        getusers();
        if (isLoadingusers) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
    }, []);

    // Local search effect
    useEffect(() => {
        handleLocalSearch();
    }, [searchTerm]);

  const getDate = (date) => new Date(date).toDateString();
  
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
            {isLoadingusers ? 'Loading Users...' : 'List of users'}
        </Typography>
        
        <Box sx={{ mb: 3 }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="Search users"
                        variant="outlined"
                        size="small"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onKeyPress={handleKeyPress}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        placeholder="Search by name, email, phone..."
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={8}>
                    {filteredUsers && (
                        <Typography variant="body2" color="textSecondary">
                            {filteredUsers.length} {filteredUsers.length === 1 ? 'user' : 'users'} found
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Box>
        
    <TableContainer component={Paper}>
        
      {filteredUsers !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>Name</TableCell>
          <TableCell align="right">Email</TableCell>
          <TableCell align="right">Phone</TableCell>
          <TableCell align="right">Password</TableCell>
          <TableCell align="right">Country</TableCell>
          <TableCell align="right">Currency</TableCell>
          <TableCell align="right">View</TableCell>
          <TableCell align="right">Profile</TableCell>
          <TableCell align="right">Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredUsers.length > 0 ? (
            filteredUsers.map((user) => (
              <TableRow
                key={user.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                    {user.name}
                </TableCell>
                <TableCell align="right">{user.email}</TableCell>
                <TableCell align="right">{user.phone}</TableCell>
                <TableCell align="right">{user.pass_copy}</TableCell>
                <TableCell align="right">{user.country}</TableCell>
                <TableCell align="right">{user.currency}</TableCell>
                <TableCell align="right"><Button component={RouterLink} to={`/user-dashboard/${user.id}`} startIcon={<EditIcon />}>View User</Button></TableCell>
                <TableCell align="right"><Avatar alt={user.name} src={user.profile} /></TableCell>
                <TableCell align="right">{getDate(user.created_at)}</TableCell>
              </TableRow>
            ))
        ) : (
            <TableRow>
                <TableCell colSpan={9} align="center">
                    No users found matching "{searchTerm}"
                </TableCell>
            </TableRow>
        )}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>
    </div>
  );
}